<ng-container class="wrapper shadowed">
    <h3 mat-dialog-title>{{data.title}}</h3>
    <div mat-dialog-content>
        <mat-label>{{data.message}}</mat-label>
    </div>
    <br/>
    <div mat-dialog-actions *ngIf="!data.forConfirmation">
        <button class="btn btn-primary" (click)="okClick()">OK</button>
    </div>
    <div mat-dialog-actions *ngIf="data.forConfirmation" id="wrapper">
        <button class="btn btn-secondary" (click)="okClick()">Annuler</button>
        <button class="btn btn-primary" (click)="confirmed()">Confirmer</button>
    </div>
</ng-container>